import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

export const partnerQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  icon: z.array(fileQuerySchema).nullish(),
});

export type PartnerQueryLinkerSchema = z.infer<typeof partnerQueryLinkerSchema>;
